import React, { useEffect } from "react";
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import AlertBox from "../../../components/common/AlertBox";
// import Logo from "../../../assets/Images/logo.png";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllRoutePlanReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearRoutePlanReportList } from "../reportsSlice";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";

const RoutePlanReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("routeplanreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .routeplanereport-print-break{
          page-break-before: always;
          }
      }
    `;
    document.head.appendChild(style);
  };

  const RoutePlanReportList = useAppSelector(
    (state) => state.reports.RoutePlanReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      distributor_id: state?.distributor_id,
      monday: state?.monday,
      tuesday: state?.tuesday,
      wednesday: state?.wednesday,
      thursday: state?.thursday,
      friday: state?.friday,
      saturday: state?.saturday,
      initialValues: state.initialValues,
    };
    const res = await dispatch(getAllRoutePlanReport(payload));
    if (res.meta.requestStatus === "fulfilled") {
      setPrintStyles();
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("routeplanreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearRoutePlanReportList());
    };
  }, []);

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {RoutePlanReportList && RoutePlanReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem>
                    <ButtonWithLoading
                      buttonStyle={{
                        position: "fixed",
                        right: 20,
                        top: 20,
                        zIndex: 100,
                      }}
                      label={"Print"}
                      className="no-visible-print-btn"
                      type="button"
                      onClick={() => window.print()}
                    />
                    <table
                      className="table table-bordered"
                      style={{ fontSize: "10px", marginBottom: "10px" }}
                    >
                      <tr>
                        {/* <td
                          rowSpan={3}
                          style={{
                            width: "200px",
                            border: "1px solid lightgray",
                          }}
                        >
                          <div style={{ height: "100px" }}>
                            <img
                              src={`${Logo}`}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </td> */}
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "20px",
                            fontWeight: 600,
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          HARIHAR FOODS PVT LTD.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            color: "gray",
                            border: "1px solid lightgray",
                            textAlign: "center",
                          }}
                        >
                          <h6 style={{ margin: 0 }}>Walking Order List</h6>
                        </td>
                      </tr>
                      {/* <tr>
                        <td
                          style={{
                            border: "1px solid lightgray",
                            // textAlign: "center",
                            fontSize: "14px",
                          }}
                        >
                          <p style={{ margin: 0 }}>
                            Distributor Name :{" "}
                            {RoutePlanReportList[0]?.distributor_name?.toUpperCase()}
                          </p>
                        </td>
                      </tr> */}
                    </table>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    {RoutePlanReportList.map((item: any, rowIndex: number) => (
                      <div
                        key={rowIndex}
                        className={`${
                          rowIndex > 0 ? "routeplanereport-print-break" : ""
                        }`}
                      >
                        <div>
                          <h6>
                            Distributor Name :{" "}
                            {item?.distributor_name?.toUpperCase()}
                          </h6>
                          <div style={{ display: "flex" }}>
                            <h6 style={{ width: "20%" }}>
                              Day : {item?.day_of_week}
                            </h6>{" "}
                            <h6>Area : {item?.area_name_list}</h6>
                          </div>
                        </div>
                        <table
                          cellSpacing={1}
                          cellPadding={2}
                          className={`table table-bordered registerreport-print`}
                        >
                          <thead>
                            <tr
                              className="text-center fw-600"
                              style={{
                                fontSize: 12,
                              }}
                            >
                              <th style={{ minWidth: 50 }}>SR. No</th>

                              {checkInclude(
                                "retailer_name",
                                formRenderProps
                              ) && (
                                <>
                                  <th style={{ minWidth: 100 }}>
                                    Retailer Name
                                  </th>
                                </>
                              )}
                              {checkInclude("area_name", formRenderProps) && (
                                <>
                                  <th style={{ minWidth: 180 }}>Area Name</th>
                                </>
                              )}
                              {checkInclude(
                                "contact_person",
                                formRenderProps
                              ) && (
                                <>
                                  <th style={{ minWidth: 200 }}>
                                    Contact Person
                                  </th>
                                </>
                              )}
                              {checkInclude("mobile_no", formRenderProps) && (
                                <>
                                  <th style={{ minWidth: 150 }}>Mobile No</th>
                                </>
                              )}
                              {checkInclude("rating", formRenderProps) && (
                                <>
                                  <th style={{ minWidth: 200 }}>Rating</th>
                                </>
                              )}
                            </tr>
                          </thead>

                          {/* Table Body */}
                          <tbody>
                            <>
                              {item?.reatiler_list.map(
                                (retailer: any, innerIndex: number) => (
                                  <tr>
                                    <td>{innerIndex + 1}</td>
                                    {checkInclude(
                                      "retailer_name",
                                      formRenderProps
                                    ) && <td>{retailer.retailer_name}</td>}
                                    {checkInclude(
                                      "area_name",
                                      formRenderProps
                                    ) && <td>{retailer.area_name}</td>}
                                    {checkInclude(
                                      "contact_person",
                                      formRenderProps
                                    ) && <td>{retailer.contact_person}</td>}
                                    {checkInclude(
                                      "mobile_no",
                                      formRenderProps
                                    ) && <td>{retailer.mobile_no}</td>}
                                    {checkInclude(
                                      "rating",
                                      formRenderProps
                                    ) && <td>{retailer.rating}</td>}
                                  </tr>
                                )
                              )}
                            </>
                          </tbody>
                        </table>
                      </div>
                    ))}
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default RoutePlanReport;
